(() => {
  if (window.ukSizeTableReady) return;
  window.ukSizeTableReady = true;
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-chart-unit]');
    if (!button) return;
    const chart = button.closest('[data-uk-size-table]');
    if (!chart) return;
    chart.dataset.unit = button.dataset.chartUnit;
    chart.querySelectorAll('[data-chart-unit]').forEach(item => {
      item.setAttribute('aria-pressed', String(item === button));
    });
  });
})();
